import React, { ReactElement } from "react";

function IconExplode({
  height = 48,
  width = 48,
}: {
  height?: number;
  width?: number;
}): ReactElement {
  return (
    <svg viewBox="0 0 110 110" width={width} height={height}>
      <g>
        <circle cx="41.5" cy="9.5" r="3.5" fill="#3ea8ff"></circle>
        <circle cx="98.5" cy="26.5" r="3.5" fill="#ffdc6e"></circle>
        <circle cx="13" cy="19" r="5" fill="#c067f4"></circle>
        <circle cx="77" cy="9" r="5" fill="#f76685"></circle>
        <circle cx="26.5" cy="92.5" r="3.5" fill="#f76685"></circle>
        <circle cx="105.5" cy="48.5" r="3.5" fill="#c067f4"></circle>
        <circle cx="4.5" cy="60.5" r="3.5" fill="#3ea8ff"></circle>
        <circle cx="94.5" cy="73.5" r="1.5" fill="#3ea8ff"></circle>
        <circle cx="16.5" cy="75.5" r="1.5" fill="#ffdc6e"></circle>
        <circle cx="78.5" cy="91.5" r="1.5" fill="#ffdc6e"></circle>
      </g>
    </svg>
  );
}

export default IconExplode;
